// extracted by mini-css-extract-plugin
export var wrapper = "index-module--wrapper--ruYmn";
export var menu = "index-module--menu--QgjOl";
export var menuIcon = "index-module--menu-icon--cudfg";
export var logo = "index-module--logo--nlzXC";
export var tabletLogo = "index-module--tabletLogo--Q3PUg";
export var headerButtonsBlock = "index-module--headerButtonsBlock--33Knt";
export var menuWrapper = "index-module--menuWrapper--xe+9X";
export var decoration = "index-module--decoration--jD8M0";
export var menuItem = "index-module--menu-item--XwhXi";
export var menuBg = "index-module--menu-bg--CkNES";
export var headerSmButtons = "index-module--headerSmButtons--gGBJz";